import { CSSProperties, ReactNode } from "react";
import "../../css/Buttons/RectangleButtonStyles.css";
import { Colors } from "../../utils/colors";
import { ThemeStyle } from "../../hooks/useTheme";

type EmptyStateButtonProps = {
  title: string | ReactNode;
  description?: string;
  icon?: ReactNode;
  iconBox?: number;
  btnText?: string;
  btnIconRight?: ReactNode;
  onPress?: () => void;
  disabled?: boolean;
  secondaryAction?: ReactNode;
  containerStyles?: CSSProperties;
  buttonContainerStyles?: CSSProperties;
  iconBackgroundColor?: string;
  theme?: ThemeStyle;
};

const EmptyStateButton = (props: EmptyStateButtonProps) => {
  const {
    title,
    description,
    icon,
    iconBox,
    btnText,
    btnIconRight,
    disabled,
    onPress,
    secondaryAction,
    containerStyles,
    buttonContainerStyles,
    iconBackgroundColor,
    theme,
  } = props;

  const styles = {
    title: {
      fontWeight: "500",
      paddingBottom: 7,
      color: theme?.PrimaryText.color || Colors.BLACK,
    },

    subtext: {
      color: Colors.GRAY2,
      fontSize: 11,
      paddingHorizontal: 40,
    },

    iconContainer: {
      justifyContent: "center",
      alignItems: "center",
      width: iconBox ?? 40,
      height: iconBox ?? 40,
      padding: 10,
      borderRadius: 16,
      backgroundColor: iconBackgroundColor ?? Colors.GRAY6,
      border: `0.5px solid ${Colors.GRAY2}`,
    },
  };

  return (
    <div className="AlignedColumn" style={containerStyles}>
      {icon ? (
        <div className="AlignedRow" style={styles.iconContainer}>
          {icon}
        </div>
      ) : null}
      <div
        style={{ paddingBlock: 14, alignItems: "center" }}
        className="ColumnNormal"
      >
        <span style={styles.title}>{title}</span>
        {description ? (
          <span style={{ ...styles.subtext, textAlign: "center", width: 300 }}>
            {description}
          </span>
        ) : null}
      </div>
      {btnText ? (
        <div
          className="ProfilePageBlackButtonText"
          style={{
            color: disabled ? Colors.GRAY1 : "",
            cursor: "pointer",
            pointerEvents: disabled ? "none" : "all",
            ...buttonContainerStyles,
          }}
          onClick={onPress}
        >
          {btnIconRight ? (
            <div
              className="AlignedRow"
              style={{ gap: 7, justifyContent: "center" }}
            >
              <span style={{ fontSize: 14, fontWeight: "500" }}>{btnText}</span>
              {btnIconRight}
            </div>
          ) : (
            <span style={{ fontSize: 14, fontWeight: "500" }}>{btnText}</span>
          )}
        </div>
      ) : null}
      {secondaryAction ? (
        <div style={{ paddingTop: 14, cursor: "pointer" }}>
          {secondaryAction}
        </div>
      ) : null}
    </div>
  );
};

export default EmptyStateButton;
